export default "__VITE_ASSET__ykmHJbcm__"